/**
 * Toán tử của search voucher
 */
export default {
  And: 'AND',
  Or: 'OR',
};
